import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getSession } from './auth-utils';

export const GuestOnlyRoute = ({component: Component, ...rest}) => {
    return (
        <Route {...rest} render={props => (
            !getSession() ?
                <Component {...props} />
            : <Redirect to="/start" />
        )} />
    );
};